export default __webpack_public_path__ + "static/media/ejs-icon.d53b5438.svg";